<template>
  <div class="home">
    <!-- <div @click="bofang">播放</div> -->
    <div v-swiper:banner="bannerSwiper">
      <div
        class="swiper-wrapper"
        :style="{ width: $store.state.fullWidth + 'px',height: $store.state.fullWidth*0.52 + 'px'  }"
      >
        <div
          class="swiper-slide"
          :style="{ width: $store.state.fullWidth + 'px',height: $store.state.fullWidth*0.52 + 'px' }"
          :key="index"
          v-for="(item, index) in banners"
        >
          <img
            class="banner-img"
            :style="{ width: $store.state.fullWidth + 'px',height: $store.state.fullWidth*0.52 + 'px' }"
            :src="item.imagePath"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="simple-order" v-if="$store.state.user.login">
      <div class="title">{{ $t("home.simpleorder") }}</div>
      <div class="sub-title">{{ $t("home.simpleorderSubtitle") }}</div>
      <div class="product common-flex common-flex-wrap">
        <div
          @mouseleave="leaveProduct(item)"
          @mouseenter="enterProduct(item)"
          class="product-item"
          v-for="(item, index) in product"
          :key="index"
        >
           <transition name="fade">
          <div class="product-item-hover" v-if="item.show">
            <div class="item-hover-name">{{ item.name }}</div>
            <div class="item-hover-subname">{{$t('home.onlycoat')}}</div>
            <div class="item-hover-btn common-hover" @click="goToOrder(item)">{{$t('home.Order')}}</div>
          </div>
          </transition>
          <img
            class="product-img"
            :src="item.imagePath"
            alt=""
          />
          <div class="product-title">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="customize">
      <div class="title">{{ $t("home.customizeTitle") }}</div>
      <div class="sub-title">{{ $t("home.customizeSubtitle") }}</div>
      <div
        class="common-flex common-justify-center"
        style="margin: 60px auto 0; width: 100%"
      >
        <div v-for="(item, index) in orderStep" :key="index">
          <div class="common-flex">
            <div class="step-radios">
              {{ item.step }}
            </div>
            <div class="step-line" v-if="index != orderStep.length - 1"></div>
          </div>
          <div class="step-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="choose-category">
      <div class="contect-category-box">
        <div class="title">{{ $t("home.step.one") }}</div>
        <div class="subtitle">{{ $t("home.chooseCate") }}</div>
        <img src="../../assets/images/hometip.png" alt="">
      </div>
    </div>
    <div class="contect-us">
      <div class="title">{{ $t("home.contectUs") }}</div>
      <div class="sub-title" style="width: 724px; margin: 19px auto 70px">
        {{ $t("home.contectUsTit") }}
      </div>
      <div class="contect-us-btn common-hover" @click="contect">{{ $t("home.contectUs") }}</div>
    </div>
  </div>
</template>

<script>
import "swiper/css/swiper.css";
import {mapActions} from 'vuex'
export default {
  name: "home",
  data() {
    return {
      simpleList:[],
      //   产品列表
      product: [
        {
          name: "Trouser1",
          show: false,
        }
      ],
      orderStep: [
        {
          name: this.$t("home.step.one"),
          step: "01",
        },
        {
          name: this.$t("home.step.two"),
          step: "02",
        },
        {
          name: this.$t("home.step.three"),
          step: "03",
        },
        {
          name: this.$t("home.step.four"),
          step: "04",
        },
        {
          name: this.$t("home.step.five"),
          step: "05",
        },
        {
          name: this.$t("home.step.six"),
          step: "06",
        },
      ],
      bannerSwiper: {
        loop: true,
        //播放速度
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      banners:[]
    };
  },
  methods: {
    ...mapActions([
      'getCategoryAction',//获得品类
      'bannerAction',//首页banner
    ]),
    
    goToOrder(e){
      this.$router.push({
          path: "./newOrder",
          query: {
            id: e.id,
          },
        });
    },
    // bofang(){
    //   let readWords = '接受这个订单'   //获取播报的文字（除去样式）
    //   var url = "http://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&text=" + encodeURI(readWords);
    //   var n = new Audio(url);
    //   n.src = url;
    //   n.play();  //播放阅读
    // },
    getBanner(){
      this.bannerAction().then(res=>{
        console.log('res',res)
        this.banners = res.data
      })
    },
    getCategory(){
      this.getCategoryAction({orderWay:7}).then(res=>{
        // console.log('categroy',res)
        res.data.map(item=>{
          item.show = false
        })
        this.product = res.data
      })
    },
    //   离开产品
    leaveProduct(e) {
      e.show = false;
    },
    // 进入产品
    enterProduct(e) {
      e.show = true;
    },
    // 跳转联系我们
    contect(){
        this.$router.push('./contect')
    }
  },
  mounted() {
    if(this.$store.state.user.login){
      this.getCategory()
    }
    this.getBanner()
    // this.getMemberAuthority()
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.fade-enter-active, .fade-leave-active {
  // transition: .5s;
  opacity: .9;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.home {
  .simple-order {
    padding-bottom: 70px;
    background: #fff;
    overflow: hidden;
  }
  .title {
    font-size: 40px;
    font-family: Times, Times-Bold;
    font-weight: 700;
    text-align: center;
    color: #081938;
    line-height: 48px;
    margin: 100px 0 25px;
  }
  .sub-title {
    opacity: 0.7;
    font-size: 14px;
    font-family: Times, Times-Roman;
    font-weight: Roman;
    text-align: center;
    color: #081938;
    line-height: 18px;
  }
  .product {
    margin: 70px auto;
    width: 1330px;
    .product-item {
      width: 190px;
      height: 249px;
      position: relative;
      .product-img {
        width: 130px;
        height: 130px;
        display: block;
        margin: 25px auto 20px;
      }
      .product-title {
        font-size: 16px;
        font-family: Times, Times-Bold;
        font-weight: 700;
        text-align: center;
        color: #081938;
        line-height: 19px;
      }
      .product-item-hover {
        width: 190px;
        height: 249px;
        background: #0a4dcc;
        opacity: 0.9;
        position: absolute;
        left: 0;
        top: 0;
        .item-hover-name {
          font-size: 24px;
          font-family: Times, Times-Bold;
          font-weight: 700;
          text-align: center;
          color: #ffffff;
          line-height: 29px;
          margin: 56px auto 25px;
          padding-bottom: 8px;
          position: relative;
        }
        .item-hover-name::after {
          content: "";
          width: 24px;
          height: 2px;
          background: #fff;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          margin-left: auto;
          margin-right: auto;
        }
        .item-hover-subname {
          font-size: 12px;
          font-family: Times, Times-Roman;
          font-weight: Roman;
          text-align: center;
          color: #ffffff;
          line-height: 14px;
          height: 28px;
        }
        .item-hover-btn {
          width: 110px;
          height: 30px;
          line-height: 30px;
          background: #ffffff;
          font-size: 12px;
          font-family: Times, Times-Bold;
          font-weight: 700;
          text-align: center;
          color: #0a4dcc;
          margin: 46px auto 0;
        }
      }
    }
  }
  .customize {
    background: #f8f8f8;
    padding: 0 0 100px;
    overflow: hidden;
    .step-radios {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: #0a4dcc;
      line-height: 36px;
      text-align: center;
      font-size: 14px;
      color: #fff;
      position: relative;
    }
    .step-radios::after {
      content: "";
      position: absolute;
      width: 0;
      height: 0;
      left: 29px;
      top: 4px;
      border-top: 14px solid transparent;
      border-left: 12px solid #0a4dcc;
      border-bottom: 14px solid transparent;
    }
    .step-name {
      opacity: 0.7;
      font-size: 14px;
      font-weight: 500;
      text-align: left;
      color: #081938;
      line-height: 16px;
      margin-top: 24px;
    }
    .step-line {
      width: 140px;
      height: 3px;
      background: #0a4dcc;
      margin: 16.5px 0 0 0;
    }
  }
  .contect-us {
    padding: 0 0 100px;
    background-color: #f8f8f8;
    overflow: hidden;
    .contect-us-btn {
      width: 215px;
      height: 53px;
      opacity: 1;
      background: #0a4dcc;
      font-size: 18px;
      font-weight: 500;
      text-align: center;
      color: #ffffff;
      line-height: 53px;
      margin: 0 auto;
    }
  }
  .choose-category {
    background: #fff;
    padding: 100px 0;
    .contect-category-box {
      width: 1015px;
      margin: 0 auto;
      img{
          width: 1015px;
          margin-top: 53px;
          display: block;
      }
    }
    .title {
      font-size: 30px;
      font-family: Times, Times-Roman;
      font-weight: Roman;
      text-align: left;
      color: #081938;
      line-height: 37px;
      margin-top: 0;
    }
    .subtitle {
      opacity: 0.7;
      font-size: 14px;
      font-family: Times, Times-Roman;
      font-weight: Roman;
      text-align: left;
      color: #081938;
      line-height: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue